import { AuthLoginResource } from "@/api/generated-api";
import { FormFieldType } from "@/components/ui/form-field/types";
import { z } from "zod";

export const LOGIN_FORM_SCHEMA = z.object({
  email: z.string().trim().min(1, "Укажите e-mail").email("Введите корректный e-mail"),
  password: z.string().min(1, "Укажите пароль"),
});

export const LOGIN_FORM_FIELDS: Array<FormFieldType & { id: keyof AuthLoginResource }> = [
  {
    id: "email",
    label: "E-mail",
    type: "email",
    autoComplete: "off",
  },
  {
    id: "password",
    label: "Пароль",
    type: "password",
    autoComplete: "current-password",
  },
];
